// extracted by mini-css-extract-plugin
module.exports = {"container":"Movie_container__2bv5R","innerDiv":"Movie_innerDiv__1bquI","overview":"Movie_overview__3VMwU","btn":"Movie_btn__2eOot","img":"Movie_img__1rQQF"};